import {Fragment, useEffect, useState} from 'react';
import {Helmet} from 'react-helmet-async';
import {useLocation} from 'react-router';
import {useMenuCurrentItem} from '@/components/menu';
import {Content, Footer, Header, Sidebar, useBuddyLayout} from '../';
import {useMenus} from '@/providers';
import { SidebarChat } from '../chat';
import FeedbackModal from "@/components/feedback/FeedbackModal.tsx";

const Main = () => {
    const {layout} = useBuddyLayout();
    const {pathname} = useLocation();
    const {getMenuConfig} = useMenus();
    const menuConfig = getMenuConfig('primary');
    const menuItem = useMenuCurrentItem(pathname, menuConfig);

    // initial mount: add base class
    useEffect(() => {
        document.body.classList.add('buddy');
        //console.log('base class buddy added');
        return () => {
            document.body.classList.remove('buddy');
            //console.log('base class buddy removed');
        };
    }, []);

    // handle sidebar and header classes
    useEffect(() => {
        /*console.group('Buddy layout: sidebar & header');
        console.log('sidebar.fixed:', layout.options.sidebar.fixed);
        console.log('sidebar.collapse:', layout.options.sidebar.collapse);
        console.log('header.fixed:', layout.options.header.fixed);
        console.groupEnd();*/

        const bodyClass = document.body.classList;
        // sidebar fixed
        if (layout.options.sidebar.fixed) {
            bodyClass.add('sidebar-fixed');
        } else {
            bodyClass.remove('sidebar-fixed');
        }
        // sidebar collapse
        if (layout.options.sidebar.collapse) {
            bodyClass.add('sidebar-collapse');
        } else {
            bodyClass.remove('sidebar-collapse');
        }
        // header fixed
        if (layout.options.header.fixed) {
            bodyClass.add('header-fixed');
        } else {
            bodyClass.remove('header-fixed');
        }
    }, [
        layout.options.sidebar.fixed,
        layout.options.sidebar.collapse,
        layout.options.header.fixed
    ]);

    // handle sidebar chat collapse independently
    useEffect(() => {
        //console.log('sidebarChat.collapse:', layout.options.sidebarChat.collapse);
        const bodyClass = document.body.classList;
        if (layout.options.sidebarChat.collapse) {
            bodyClass.add('sidebar-chat-collapse');
        } else {
            bodyClass.remove('sidebar-chat-collapse');
        }
    }, [layout.options.sidebarChat.collapse]);

    // layout-initialized indicator
    useEffect(() => {
        const timer = setTimeout(() => {
            document.body.classList.add('layout-initialized');
            /*console.log('layout-initialized class added');*/
        }, 1000);

        return () => {
            document.body.classList.remove('layout-initialized');
            clearTimeout(timer);
            /*console.log('layout-initialized class removed');*/
        };
    }, []);

    const [isFeedbackOpen, setFeedbackOpen] = useState(false);

    return (
        <Fragment>
            <Helmet>
                <title>{menuItem?.title}</title>
            </Helmet>

            <div className="flex grow">
                <Sidebar />
                <div className="wrapper flex grow flex-col">
                    <Header />

                    <Content />

                    <Footer onFeedbackClick={() => setFeedbackOpen(true)} />
                    <FeedbackModal isOpen={isFeedbackOpen} onClose={() => setFeedbackOpen(false)} />

                </div>
            </div>
        </Fragment>
    );
};

export {Main};
